import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const api = axios.create({
 baseURL: process.env.REACT_APP_API_URL + "/api",
});


// Attach token automatically (support multiple storage schemes)
api.interceptors.request.use((config) => {
 try {
 let token = localStorage.getItem("token");

 if (!token) {
 const ud = localStorage.getItem("userDetails");
 if (ud) {
 try {
 const parsed = JSON.parse(ud);
 token = parsed?.token || parsed?.accessToken || null;
 } catch (e) {
 }
 }
 }

 if (token) {
 config.headers = config.headers || {};
 config.headers.Authorization = `Bearer ${token}`;
 }

 } catch (err) {
 }
 return config;
}, (error) => Promise.reject(error));


// [OK] AUTO LOGOUT ONLY WHEN TOKEN IS INVALID
api.interceptors.response.use(
 (response) => response,
 (error) => {
 if (axios.isCancel(error)) {
 return Promise.reject(error);
 }
 const status = error.response?.status;
 const suppressErrorToast = error.config?.suppressErrorToast;

 // Logout ONLY on 401 (invalid / expired token)
 if (status === 401) {
 localStorage.removeItem("token");
 localStorage.removeItem("userDetails");
 window.location.href = "/";
 }

 // SHOW POPUP FOR 403 (Restricted Access)
 else if (status === 403) {
 Swal.fire({
 title: "Restricted Access",
 text: "You currently don't have access to this feature. Please contact your administrator if access is required.",
 icon: "info",
 confirmButtonText: "OK",
 confirmButtonColor: "#3085d6",
 });
 }

 // [ERROR] Show toast for other errors (like 400, 422, 500)
 else if (!suppressErrorToast) {
 const msg = error.response?.data?.message || error.response?.data?.error || error.message || "Something went wrong!";
 toast.error(msg, { autoClose: 3000 });
 }

 // [ERROR] Do NOT logout for 403 / 440 / 400 / 500
 return Promise.reject(error);
 }
);

export const getFileUrl = (fileUrl) => {
 if (!fileUrl) return "";
 
 // Remove any accidental leading slashes before checking for http
 const cleanUrl = fileUrl.toString().trim().replace(/\\/g, "/");
 
 if (cleanUrl.startsWith("data:") || cleanUrl.startsWith("blob:")) return cleanUrl;

 if (cleanUrl.startsWith("http")) return cleanUrl;
 
 // If it contains http but not at the start (e.g. /http://...), fix it
 if (cleanUrl.includes("http")) {
 const startIndex = cleanUrl.indexOf("http");
 return cleanUrl.substring(startIndex);
 }

 let baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

 // FIX: Strip /api if it was accidentally included in the base URL
 if (baseUrl.endsWith("/api")) {
 baseUrl = baseUrl.slice(0, -4);
 }
 
 // Ensure baseUrl has a protocol
 if (baseUrl && !baseUrl.startsWith("http")) {
 baseUrl = `https://${baseUrl}`;
 }

 const path = cleanUrl.startsWith("/") ? cleanUrl : `/${cleanUrl}`;
 return `${baseUrl}${path}`;
};

export default api;
